import React, { useMemo, useCallback, cloneElement, isValidElement } from "react";
import logger from "../../../services/logger";

export function InputFormatter({
								   value,
								   onChange,
								   format,
								   parse,
								   children,
							   }) {
	const formattedValue = useMemo(() => {
		return format(value);
	}, [value, format]);

	const handleChange = useCallback(
		(eventOrValue) => {
			// Support input classique OU value directe
			const rawValue =
				eventOrValue?.target?.value ?? eventOrValue;

			const transformed = parse
				? parse(rawValue)
				: format(rawValue);

			onChange(transformed);
		},
		[onChange, parse, format]
	);

	// Sécurité minimale
	if (!isValidElement(children)) {
		logger.warn("InputFormatter attend un seul enfant React valide.");
		return null;
	}

	return cloneElement(children, {
		value: formattedValue,
		onChange: handleChange,
	});
}
